"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var list_exports = {};
__export(list_exports, {
  getOrderedListStart: () => getOrderedListStart
});
module.exports = __toCommonJS(list_exports);
function getOrderedListStart(attrs) {
  const value = attrs?.start ?? attrs?.order;
  if (typeof value !== "number" && (typeof value !== "string" || !/^[+-]?\d+$/.test(value.trim()))) {
    return 1;
  }
  const start = Number(value);
  return Number.isSafeInteger(start) ? start : 1;
}
__name(getOrderedListStart, "getOrderedListStart");
//# sourceMappingURL=list.js.map
